import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment";
import { EditProfileQueryData, EditProfileFetchedData, SubmitEditProfileData, SubmitEntityData, SubmitEntityExtraData } from 'globals/store/share.data';
import { HttpClient } from '@angular/common/http';
import { take } from 'rxjs/operators';
import { CustomQuestion } from 'globals/store/events.data';

@Injectable({ providedIn: 'root' })
export class PublicService { 

  readonly api = `${environment.functionsURL}api/v1`;
  readonly _file = 'public.service.ts'
  
  constructor(
    private http:HttpClient,
  ) {} // DON'T INITIALIZE OTHER APP SERVICES IN THIS SERVICE!!!


  async loadSubmitEntityExtraData(queryData: SubmitEntityData): Promise<SubmitEntityExtraData> {
    const url = `${this.api}/check-can-submit-entity-get-custom-questions`
    try {
      console.log({ queryData })
      const questions = await this.http.post(url, queryData).pipe(take(1)).toPromise()
      console.log({ questions })
      return questions as SubmitEntityExtraData
    } catch (response) {
      console.log(response)
      return null
    }
  }

  async submitEntity(submitData: SubmitEntityData): Promise<boolean> {
    try {
      const url = `${this.api}/submit-entity`
      await this.http.post(url, submitData).pipe(take(1)).toPromise()
      return true
    } catch (response) {
      console.log(response)
      return false
    }
  }
  async loadEditProfile(queryData: EditProfileQueryData): Promise<EditProfileFetchedData> {
    const url = `${this.api}/load-edit-profile-by-code`
    try {
      console.log({ queryData })
      const profile = await this.http.post(url, queryData).pipe(take(1)).toPromise()
      return profile as EditProfileFetchedData
    } catch (response) {
      console.log(response)
      return null
    }
  }

  async checkForMandatory(questions: CustomQuestion[], submittedData ): Promise<boolean>{
    let mandatoryButEmpty = questions.filter(question=>{
      if (!question.isMandatory) return false;
      switch(question.type){
        case "free":
          if (submittedData[question.id] === "") return true;
          break;
        case "checkbox":
          if (!submittedData[question.id] === false) return true;
          break;
        case "radio":
          if (submittedData[question.id] === null) return true;
          break;
        case "link":
        case "stars":
          if (!submittedData[question.id]) return true;
          break;
        default:
          return false;
      }
    })
    
    return mandatoryButEmpty.length === 0;
  }

  async submitEditProfile(submitData: SubmitEditProfileData): Promise<boolean> {
    const url = `${this.api}/submit-profile`
    try {
      const profile = await this.http.post(url, submitData).pipe(take(1)).toPromise()
      console.log({ profile, submitData })
      return true
    } catch (response) {
      console.log(response)
      return false
    }
  }
}
